import { FaSms, FaWhatsapp } from 'react-icons/fa';
import { normaliseNigerianPhone } from '../../utils/arrears/phone';
import { buildSmsUrl, buildWhatsAppUrl } from '../../utils/arrears/reminders';

interface ChannelActionsProps {
  /** Raw phone number from the contact record, if any. */
  phone?: string | null;
  /** What the landlord has typed so far; sent along as the prefilled text. */
  draft: string;
}

const BASE =
  'flex h-9 items-center gap-1.5 rounded-lg px-2.5 text-sm font-medium text-white/90 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white';
const ENABLED = `${BASE} hover:bg-white/15 hover:text-white`;
const DISABLED = `${BASE} cursor-not-allowed opacity-50`;

/**
 * "Message on WhatsApp" and "Send SMS" for a person's thread. They open the
 * landlord's own WhatsApp / messaging app with the draft prefilled (the same
 * links the arrears page uses); nothing is sent from here. Without a valid
 * Nigerian mobile number both are disabled and the reason is the tooltip.
 */
export default function ChannelActions({ phone, draft }: ChannelActionsProps) {
  const result = normaliseNigerianPhone(phone);

  if (!result.ok) {
    return (
      <>
        {[
          { label: 'Message on WhatsApp', Icon: FaWhatsapp },
          { label: 'Send SMS', Icon: FaSms },
        ].map(({ label, Icon }) => (
          <span key={label} title={result.reason}>
            <button type="button" disabled aria-label={label} aria-description={result.reason} className={DISABLED}>
              <Icon className="h-4 w-4" aria-hidden />
            </button>
          </span>
        ))}
      </>
    );
  }

  return (
    <>
      <a
        href={buildWhatsAppUrl(result.digits, draft)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Message on WhatsApp"
        title={`WhatsApp ${result.display}`}
        className={ENABLED}
      >
        <FaWhatsapp className="h-4 w-4" aria-hidden />
      </a>
      <a href={buildSmsUrl(result.digits, draft)} aria-label="Send SMS" title={`SMS ${result.display}`} className={ENABLED}>
        <FaSms className="h-4 w-4" aria-hidden />
      </a>
    </>
  );
}
